import { TELEGRAM, TWITTER } from "./constants";

import { ReactComponent as Twitter } from "@images/socials/twitter.svg";
import { ReactComponent as Telegram } from "@images/socials/telegram.svg";

export const socialLinks = [
  {
    title: "X",
    href: TWITTER,
    icon: <Twitter />
  },
  {
    title: "Telegram",
    href: TELEGRAM,
    icon: <Telegram />
  }
];
